import request from '@/utils/request';
export const closeTask = (data: any) =>
  request({
    url: 'TaskExport/closeTask',
    method: 'put',
    data
  });
